<template>
  <v-app>
    <v-main>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title>Dashboard</v-card-title>
              <v-card-text> Welcome to your Dashboard! </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "DashboardView",
};
</script>

<style scoped>
/* Custom styles for Dashboard */
</style>
